$(document).ready(function () {
  $('.banner-section .banner-list').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });

  // $(".products-slider .product-list").slick({
  //     infinite: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     dots: false,
  //     responsive: [
  //       {
  //         breakpoint: 1280,
  //         settings: {
  //           slidesToScroll: 1,
  //           slidesToShow: 3.3,
  //         },
  //       },
  //       {
  //         breakpoint: 880,
  //         settings: {
  //           slidesToScroll: 1,
  //           slidesToShow: 2.3,
  //         },
  //       },
  //       {
  //         breakpoint: 640,
  //         settings: {
  //           slidesToScroll: 1,
  //           slidesToShow: 1.3,
  //         },
  //       }
  //     ]
  //   });  
  
  // $('.marquee-left').marquee({
  //   direction: 'left',
  //   duration: 40000,
  //   delayBeforeStart: 0,
  //   duplicated: true,
  //   gap: 0,
  //   startVisible: true
  // });

});

$(document).ready(function () {

    function initCollectionSlider($slider) {

        if (!$slider.length) return;

        if ($slider.hasClass("slick-initialized")) {
            $slider.slick("unslick");
        }

        $slider.slick({
            infinite: false,
            slidesToShow: 3.2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.2
                    }
                }
            ]
        });
    }


    // ===========================
    // Initialize Tabs
    // ===========================
    $(".tab-container").each(function () {

        var $container = $(this);

        $container.find(".tab_content").hide();

        $container.find("ul.tabs li").removeClass("active");
        $container.find("ul.tabs li:first").addClass("active");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $container.find(".tab_drawer_heading:first").addClass("d_active");

        var $firstContent = $container.find(".tab_content:first");

        // Temporarily make visible
        $firstContent.css({
            display: "block",
            visibility: "hidden"
        });

        initCollectionSlider(
            $firstContent.find(".product-list")
        );

        // Make visible after Slick is ready
        $firstContent.css({
            visibility: "visible"
        });
    });


    // ===========================
    // Common Tab Change
    // ===========================
    function changeTab($container, activeTab) {

        var $newContent = $container.find("#" + activeTab);

        if (!$newContent.length) return;

        // Hide current
        $container.find(".tab_content").hide();

        // Show new content but keep invisible
        $newContent.css({
            display: "block",
            visibility: "hidden"
        });

        // Initialize Slick BEFORE making it visible
        initCollectionSlider(
            $newContent.find(".product-list")
        );

        // Now show it
        $newContent.css({
            visibility: "visible"
        });
    }


    // ===========================
    // Tab Click
    // ===========================
    $("ul.tabs li").on("click", function (e) {

        e.preventDefault();

        var $this = $(this);
        var $container = $this.closest(".tab-container");
        var activeTab = $this.attr("rel");

        $container.find("ul.tabs li").removeClass("active");
        $this.addClass("active");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $container
            .find(".tab_drawer_heading[rel='" + activeTab + "']")
            .addClass("d_active");

        changeTab($container, activeTab);
    });


    // ===========================
    // Drawer Click
    // ===========================
    $(".tab_drawer_heading").on("click", function () {

        var $this = $(this);
        var $container = $this.closest(".tab-container");
        var activeTab = $this.attr("rel");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $this.addClass("d_active");

        $container.find("ul.tabs li").removeClass("active");
        $container
            .find("ul.tabs li[rel='" + activeTab + "']")
            .addClass("active");

        changeTab($container, activeTab);
    });


    // Last Tab Class
    $("ul.tabs li:last").addClass("tab_last");

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.footer-block').forEach(function (block) {

    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    heading.addEventListener('click', function () {
      block.classList.toggle('is-open');
    });

  });
});

document.addEventListener('DOMContentLoaded', function () {
  const stickyMenuToggle = document.querySelector('.sticky-menu-toggle');
  const defaultMenuButton = document.querySelector('.menu-drawer-container summary');
  if (!stickyMenuToggle || !defaultMenuButton) return;

  stickyMenuToggle.addEventListener('click', function () {
    defaultMenuButton.click();
  });
});



